import { hasRole, canAction } from "@utils/accessHelper";

export default {
  computed: {
    useActionPermissions() {
      const profile = this.$store.getters.getProfile || this.$store.state.user.user || {}
      return !!profile.use_action_permissions
    },
    userRoleNames() {
      const profile = this.$store.getters.getProfile || this.$store.state.user.user || {}
      const { adm_roles = [] } = profile
      return adm_roles.map(r => r.name)
    },
    admRoleNames() {
      const roles = this.$store.getters.getAdmRoles || this.$store.getters['admRoles'] || []
      return roles.map(r => r.name)
    },
    screenPermissions() {
      const profile = this.$store.getters.getProfile || this.$store.state.user.user || {}
      const { screen_action_permissions = [] } = profile
      return screen_action_permissions
    }
  },
  methods: {
    $hasRole(role) {
      return hasRole(this.$store, role)
    },
    $canAction(check, level) {
      return canAction(this.$store, check, level)
    }
  }
}
